import { render, staticRenderFns } from "./ConfigContent.vue?vue&type=template&id=07d1599c"
import script from "./ConfigContent.vue?vue&type=script&lang=js"
export * from "./ConfigContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports